/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Custom field value request
 * @export
 * @interface CustomFieldValueRequest
 */
export interface CustomFieldValueRequest {
    /**
     * 
     * @type {any}
     * @memberof CustomFieldValueRequest
     */
    value: any | null;
}

/**
 * Check if a given object implements the CustomFieldValueRequest interface.
 */
export function instanceOfCustomFieldValueRequest(value: object): value is CustomFieldValueRequest {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function CustomFieldValueRequestFromJSON(json: any): CustomFieldValueRequest {
    return CustomFieldValueRequestFromJSONTyped(json, false);
}

export function CustomFieldValueRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomFieldValueRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function CustomFieldValueRequestToJSON(json: any): CustomFieldValueRequest {
    return CustomFieldValueRequestToJSONTyped(json, false);
}

export function CustomFieldValueRequestToJSONTyped(value?: CustomFieldValueRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
    };
}

